import React, { HTMLAttributes, forwardRef, useImperativeHandle, useRef } from 'react';
import './SliderArrowGroup.css';
import { Row, Col } from '../../../importCL';
interface ISliderArrowGroupProps extends HTMLAttributes<any> {
    slide?: number;
    count?: number;
    windowScreen?: number;
}

// eslint-disable-next-line react/display-name
export const SliderArrowGroup = forwardRef((props: ISliderArrowGroupProps, ref) => {
    const nextArrowRef = useRef<HTMLButtonElement>(null);
    const previousArrowRef = useRef<HTMLButtonElement>(null);
    const slidesShown = props.windowScreen && props.windowScreen >= 768 ? 3 : 2;
    const viewingMessage = (
        <>
            Viewing{' '}
            <strong>{`${props.slide !== undefined && props.slide + 1} - ${
                props.slide !== undefined && props.slide + slidesShown
            }`}</strong>{' '}
            of <strong>{props.count}</strong>
        </>
    );

    useImperativeHandle(ref, () => {
        return {
            nextArrowRef: nextArrowRef,
            previousArrowRef: previousArrowRef,
        };
    });

    return (
        <Row align='center' className='SliderArrowGroup'>
            <Col xs={1}>
                <button
                    ref={previousArrowRef}
                    className={`SliderArrowGroup--left ${
                        props.slide === 0 ? 'disabled' : ''
                    }`}
                    disabled={props.slide as number <= 0}>
                    <span className='SliderArrowGroup__arrowLeft'/>
                </button>
            </Col>
            <Col>
                <h3 className='SliderArrowGroup__text'>{viewingMessage}</h3>
            </Col>
            <Col xs={1}>
                <button
                    ref={nextArrowRef}
                    className={`SliderArrowGroup--right ${
                        props.count &&
                        props.slide !== undefined &&
                        props.slide === props?.count - slidesShown
                            ? 'disabled'
                            : ''
                    }`}
                    disabled={props.slide === (props.count as number - slidesShown)}>
                    <span className='SliderArrowGroup__arrowRight'/>
                </button>
            </Col>
        </Row>
    );
});